import { atom } from 'jotai';

export const pageTitleAtom = atom<string>('');
